import { Fragment } from "react";
import { Link } from "react-router-dom";

function AffiliateBanner({ content }) {
  return (
    <Fragment>
      <div className="affiliate-banner-container">
        <div className="affiliate-banner-left">
          <img
            src={process.env.PUBLIC_URL + "/images/affiliate_banner.svg"}
            alt={content.image_alt}
            loading="lazy"
          />
        </div>
        <div className="affiliate-banner-right">
          <h3>{content.heading}</h3>
          <div className="affiliate-tag">{content.badge}</div>
          <p>{content.description}</p>
          <Link to="/affiliate-program" className="cta-button secondary">
            {content.cta}
          </Link>
        </div>
      </div>
    </Fragment>
  );
}

export default AffiliateBanner;
